import _ from 'lodash'

const CHANGED_AFTER_IMPLEMENTATION = 'Changed after implementation'

// changed_since_implemented_at is an ISO string when the planned item changed after it was implemented,
// null when it has not, and absent from responses that predate it; only a value counts as changed.
const isChanged = item => item.changed_since_implemented_at != null

// With several implementations the note names the changed ones; with one it needs no names.
const changeNote = (changedNames, implementationCount) => {
  if (changedNames.length === 0) return null
  return implementationCount > 1 ? `${CHANGED_AFTER_IMPLEMENTATION} (${changedNames.join(', ')})` : CHANGED_AFTER_IMPLEMENTATION
}

// The note for an integration panel, from the integration's `implementations` on the layout query.
export const integrationChangeNote = implementations =>
  changeNote(implementations.filter(isChanged).map(item => item.partner_name), implementations.length)

const holdsFlow = plannedFlowUuid => implementation =>
  implementation.flows.some(item => item.planned_flow_uuid === plannedFlowUuid)

// The names of the implementations holding a copy of a planned flow, once each, oldest first.
export const flowImplementationNames = (implementations, plannedFlowUuid) =>
  _.uniq(implementations.filter(holdsFlow(plannedFlowUuid)).map(item => item.partner_name))

// The note for a planned flow's card, from the implemented copies of that flow across the implementations.
export const flowChangeNote = (implementations, plannedFlowUuid) => {
  const holders = implementations.filter(holdsFlow(plannedFlowUuid))
  const changed = holders.filter(implementation =>
    implementation.flows.some(item => item.planned_flow_uuid === plannedFlowUuid && isChanged(item)))
  return changeNote(_.uniq(changed.map(item => item.partner_name)), holders.length)
}
